import DisciplinasIndexPage from "@/Pages/Disciplinas/index.vue";
import NewEditDisciplinaPage from "@/Pages/Disciplinas/NewEditDisciplinaPage.vue";

export default [
  {
    path: "/componentes-curriculares/",
    name: "disciplinas",
    component: DisciplinasIndexPage,
  },
  {
    path: "/componentes-curriculares/create",
    name: "disciplinas.create",
    component: NewEditDisciplinaPage,
    props: { editing: false },
  },
  {
    path: "/componentes-curriculares/edit/:disciplina_id",
    name: "disciplinas.edit",
    component: NewEditDisciplinaPage,
    props: { editing: true },
  },
];
